import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  Badge
} from "reactstrap"
import api from "helpers/Api"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
//components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as followupAction from "../../../store/b3BlcmF0aW9uc015Rm9sbG9/actions"
import * as updateAction from "../../../store/b3BlcmF0aW9uc01hbmFnZUZ/actions"
import ButtonSpinner from "../../../components/ButtonSpinner"
import { toast, ToastContainer } from "react-toastify"

const OperationsMyFollowup = (props) => {
  const { dispatch, searchBtnStyle } = props
  const title = "Operations My Followup"

  //Search bar and validations   
  const specificDispatch = useDispatch()
  const empId = localStorage.getItem("empId")
  useEffect(() => {
    dispatch(followupAction.loadRecordsMetaData())
    dispatch(
      followupAction.loadFollowup({
        page: 1,
        limit: 50,
        CRM_Id: empId
      })
    )
  }, [])

  const ticketUpdate = useSelector((state) => state.operationsMyFollowUp)

  const { followup_details = [], recordsMetaData = {} } = ticketUpdate


  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  const [pageCount, setPageCount] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState([])
  const [searchValueList, setSearchValueList] = useState({})
  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,
          CRM_Id: empId
        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          searchFilter: searchInput,
          CRM_Id: empId
        }
  const [downloadLoading, setDownloadLoading] = useState(false)

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //filter section initial state setOperationsFollowupData

  const [operationsFollowupData, setOperationsFollowupData] = useState({
    eventFromDate: "",
    eventToDate: "",
    previousFollowupFromDate: "",
    previousFollowupToDate: ""
  })

  const [clientProfileStatus, setClientProfileStatus] = useState([])

  //Handle change

  const handleChange = async (e) => {
    setOperationsFollowupData({
      ...operationsFollowupData,
      [e.target.name]: e.target.value,
    })
  }
  //client profile status options
  const clientProfileStatusOptions = [
    { label: "VIP", value: "VIP" },
    { label: "VVIP", value: "VVIP" },
    { label: "OTHERS", value: "OTHERS" },
  ]
  const [followupStatusModal, setFollowupStatusModal] = useState(false)
  const [followupReason, setFollowupReason] = useState([])
  //isEscalationCall checkbox
  const [isEscalationCall, setIsEscalation] = useState("")

  const statusList = [
    {
      label: "Is Escalation Call",
      value: true,
    },
  ]

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setIsEscalation(value)
    } else {
      setIsEscalation(false)
    }
  }

    //isEscalationCall client checkbox
    const [isEscalationClient, setIsEscalationClient] = useState("")

    const statusClientList = [
      {
        label: "Is Escalation Client",
        value: true,
      },
    ]
   const handleStatusClientChange = async (e, value) => {
     let isChecked = e.target.checked
 
     if (isChecked) {
       setIsEscalationClient(value)
     } else {
       setIsEscalationClient(false)
     }
   }
   const [clientType, setClientType] = useState([])
  //RESET FILTER
  const resetForm = () => {
    setIsEscalation(false)
    setIsEscalationClient(false)
    setFollowupReason([])
    setSearchInput("")
    setOperationsFollowupData({
      eventFromDate: "",
      eventToDate: "",
      previousFollowupFromDate: "",
      previousFollowupToDate: ""
    })

    setClientProfileStatus([])
    dispatch(
      followupAction.loadFollowup({
        page: 1,
        limit: 50,
        CRM_Id: empId
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)

  //Apply filter submit
  const followupReasons = !isEmpty(followupReason) ? followupReason.map(m => m.value) : ""
  const applyFilter = (e) => {
    e.preventDefault()

    var searchClientProfileStatus = !isEmpty(clientProfileStatus)
      ? clientProfileStatus.value
      : ""

    var searchEventFromDate =
      operationsFollowupData && operationsFollowupData.eventFromDate
        ? moment(operationsFollowupData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchEventToDate =
      operationsFollowupData && operationsFollowupData.eventToDate
        ? moment(operationsFollowupData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchPreviousFromDate =
      operationsFollowupData && operationsFollowupData.previousFollowupFromDate
        ? moment(operationsFollowupData.previousFollowupFromDate).format("YYYY-MM-DD")
        : ""
    var searchPreviousToDate =
      operationsFollowupData && operationsFollowupData.previousFollowupToDate
        ? moment(operationsFollowupData.previousFollowupToDate).format("YYYY-MM-DD")
        : ""
    var searchEscalation = isEscalationCall
      ? isEscalationCall
      : ""
    var searchFollowupReason = !isEmpty(followupReason)
      ? followupReasons
      : ""
      var searchEscalationClient = isEscalationClient
      ? isEscalationClient
      : ""
    var searchClientType = !isEmpty(clientType)
      ? clientType.value
      : ""
    var searchValue = {}
    searchValue.page = pageChange ? pageCount : 1
    searchValue.limit = sizePerPage ? sizePerPage : 50
    searchValue.CRM_Id = empId

    if (searchClientProfileStatus) {
      searchValue.clientStatus = searchClientProfileStatus
    }

    if (searchEventFromDate) {
      searchValue.futureFollowupFromDate = searchEventFromDate
    }
    if (searchEventToDate) {
      searchValue.futureFollowupToDate = searchEventToDate
    }
    if (searchPreviousFromDate) {
      searchValue.previousFollowupFromDate = searchPreviousFromDate
    }
    if (searchPreviousToDate) {
      searchValue.previousFollowupToDate = searchPreviousToDate
    }
    if (searchFollowupReason) {
      searchValue.followupReasonId = searchFollowupReason
    }
    if (searchEscalation) {
      searchValue.isEscalationCall = searchEscalation
    }
    if (searchEscalationClient) {
      searchValue.isEscalationClient = searchEscalationClient
    }
    if (searchClientType) {
      searchValue.clientType = searchClientType
    }
    setSearchValueList(searchValue)

    specificDispatch(followupAction.loadFollowup(searchValue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }
  const [followupDetails, setFollowupDetails] = useState("")
  //clientDetailsReportTable
  const clientDetailsReportTable =
    !isEmpty(followup_details) &&
      followup_details.data &&
      followup_details.data.length > 0
      ? followup_details.data.map((data, index) => {
        const eventName = data && data.events && !isEmpty(data.events) ?
          data.events.filter((m) => m.eventname !== null && m.eventname !== undefined)
            .map(m => m.eventname).join(",") : "--"

        const eventDate = data && data.eventsDates && !isEmpty(data.eventsDates) ?
          data.eventsDates.filter((date) => date !== null && date !== undefined)
            .map(m => moment(m).format(dateFormate)).join(",") : "--"

        return {
          _id: data._id,
          sNo: index + 1,
          clientCode: data.clientCode ? data.clientCode : "--",
          clientName: data.clientName ? data.clientName : "--",
          clientStatus: data.clientStatus ? data.clientStatus : "--",
          leadNo: data.leadNo ? data.leadNo : '--',
          leadId: data.leadId,
          eventName: eventName,
          eventDate: eventDate,
          crmName: data.CRM_Name ? data.CRM_Name : "--",
          followupDate: data.futureFollowUpDate ? moment(data.futureFollowUpDate).format(dateFormate) : "--",
          modeOfFollowup: data.futureModeOfFollowup ? data.futureModeOfFollowup : "--",
          futureRemarks: data.futureFollowupRemarks ? data.futureFollowupRemarks : "--",
          issuesCount: data.issuesCount ? data.issuesCount : "--",
          followupStatus: data.followupStatus ? data.followupStatus : "--",
          aging: data.ageing ? Math.abs(data.ageing) : "--",
          previousAttachment: data.previousFollowupAttachment ? data.previousFollowupAttachment : [],
          previousRemarks: data.previousFollowupRemarks ? data.previousFollowupRemarks : "--",
          brideName: data.brideName ? data.brideName : "--",
          groomName: data.groomName ? data.groomName : "--",
          createdByName: data.createdByName ? data.createdByName : "--",
          previousFollowupDate: data.followupDate ? moment(data.followupDate).format(dateFormate) : "--",
          isFirstFollowup: data.isFirstFollowup,
          rowData: data,
          isEscalationCall: data.isEscalationCall,
          followupReason: !isEmpty(data.followupReason) ? data.followupReason.map((m) => m.reasonName).join(",") : "--",
          isClientCompleted:data.isClientCompleted,
          clientType: data.clientType,
          isEscalationClient:data.isEscalationClient
        }
      })
      : []
  //columns for data table
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      // expandRow: false,
    },

    {
      dataField: "leadNo",
      text: "Lead No",
      hidden: false,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      formatter: (cellContent, row) => {
        const crmData = row.rowData
        return (
          <>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row.leadId}`,
                state: {
                  row: crmData,
                  leadClientId: crmData,
                  mode: "Operations",
                },
              }}
            >
              <span>{row.leadNo}</span>
            </Link>
          </>
        )
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "isEscalationCall",
      text: "Is Escalation Call",
      hidden: false,
      formatter: (cellContent) => {

        return (
          <Badge
            color={cellContent == true ? "success" : "danger"}
            style={{ padding: "6px 8px", fontSize: "12px" }}
          >
            {cellContent == true ? "Yes" : "No"}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "isEscalationClient",
      text: "Is Escalation Client",
      hidden: false,
      formatter: (cellContent) => {

        return (
          <Badge
            color={cellContent == true ? "success" : "danger"}
            style={{ padding: "6px 8px", fontSize: "12px" }}
          >
            {cellContent == true ? "Yes" : "No"}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "195px",
      },
    },
    {
      dataField: "clientType",
      text: "Client Type",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "100px",
      },
      formatter: (cellContent) => {

        let badgeStyle

        // Determine the badge style based on cell content
        switch (cellContent) {
          case "Green":
            badgeStyle = { backgroundColor: "#28a745" } // Bootstrap success color 
            break

          case "Orange":
            badgeStyle = { backgroundColor: "#FFA500" } //  orange color
            break
          case "Blue":
            badgeStyle = { backgroundColor: "#033dfc" } // Blue color
            break
          default:
            badgeStyle = {}
        }


        return (
          <div style={{ textAlign: "center", justifyContent: "center" }}>
            {cellContent ? (
              <span
                className={"badge"}
                style={{
                  ...badgeStyle,
                  display: "inline-block",
                  width: "35px",        // Equal width and height for a circle
                  height: "35px",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <span>--</span>
              // Show '--' if cellContent is empty
            )}
          </div>)

      }
    },//
    {
      dataField: "followupReason",
      text: "Followup Reason",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventName",
      text: "Event",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "crmName",
      text: "CRM Name",
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "previousFollowupDate",
      text: "Previous Followup Date",
      hidden: false,
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "followupDate",
      text: "Future Followup Date",
      hidden: false,
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "modeOfFollowup",
      text: "Mode Of FOllowup",
      hidden: false,
      headerStyle: {
        minWidth: "175px",
      },
    },
    {
      dataField: "createdByName",
      text: "Followed By",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "futureRemarks",
      text: "Future Remarks",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },

    {
      dataField: "issuesCount",
      text: "Issues Count",
      hidden: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "followupStatus",
      text: "Followup Status",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "aging",
      text: "Aging",
      hidden: false,
      headerStyle: {
        minWidth: "136px",
      },
    },

    {
      dataField: "previousAttachment",
      text: "Previous Call Followup Attachment",
      hidden: false,
      headerStyle: {
        minWidth: "270px",
      },
      formatter: (cellContent, row) => {
        const attachmentURL = !isEmpty(row.previousAttachment) ? row.previousAttachment[0] : ""
        return (
          !isEmpty(row.previousAttachment) ? (<div><a onClick={() => window.open(attachmentURL, "_blank")}>
            <span
              style={{
                textDecoration: "underline",
                color: "#E40D8C",
              }}
            >
              View
            </span>
          </a> </div>) : ("--")

        )
      },
    },
    {
      dataField: "previousRemarks",
      text: "Previous Followup Remarks",
      hidden: false,
      headerStyle: {
        minWidth: "225px",
      },
    },
    {
      dataField: "followupStatus",
      text: "Followup Status",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent, row) => {

        return (
          <Button className={row.followupStatus == "Close" ? "btb btn-danger" : "btn btn-success"}
          disabled={row.isClientCompleted === false && row.isFirstFollowup === true}
            onClick={() => {
              setFollowupStatusModal(true)
              setFollowupDetails(row)
            }}>
            {row.followupStatus == "Close" ? "Close" : "Open"}
          </Button>
        )
      },
    },


  ]
  //Columns section
  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  const [loading, setLoading] = useState(false)

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)

    dispatch(
      followupAction.loadFollowup({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
        CRM_Id: empId
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {

    var searchClientProfileStatus = !isEmpty(clientProfileStatus)
      ? clientProfileStatus.value
      : ""

    var searchEventFromDate =
      operationsFollowupData && operationsFollowupData.eventFromDate
        ? moment(operationsFollowupData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchEventToDate =
      operationsFollowupData && operationsFollowupData.eventToDate
        ? moment(operationsFollowupData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchPreviousFromDate =
      operationsFollowupData && operationsFollowupData.previousFollowupFromDate
        ? moment(operationsFollowupData.previousFollowupFromDate).format("YYYY-MM-DD")
        : ""
    var searchPreviousToDate =
      operationsFollowupData && operationsFollowupData.previousFollowupToDate
        ? moment(operationsFollowupData.previousFollowupToDate).format("YYYY-MM-DD")
        : ""
    var searchEscalation = isEscalationCall
      ? isEscalationCall
      : ""
    var searchFollowupReason = !isEmpty(followupReason)
      ? followupReasons
      : ""
      var searchEscalationClient = isEscalationClient
      ? isEscalationClient
      : ""
    var searchClientType = !isEmpty(clientType)
      ? clientType.value
      : ""
    var searchValue = {}

    if (searchClientProfileStatus) {
      searchValue.clientStatus = searchClientProfileStatus
    }

    if (searchEventFromDate) {
      searchValue.futureFollowupFromDate = searchEventFromDate
    }
    if (searchEventToDate) {
      searchValue.futureFollowupToDate = searchEventToDate
    }
    if (searchPreviousFromDate) {
      searchValue.previousFollowupFromDate = searchPreviousFromDate
    }
    if (searchPreviousToDate) {
      searchValue.previousFollowupToDate = searchPreviousToDate
    }
    if (searchFollowupReason) {
      searchValue.followupReasonId = searchFollowupReason
    }
    if (searchEscalation) {
      searchValue.isEscalationCall = searchEscalation
    }
    if (searchEscalationClient) {
      searchValue.isEscalationClient = searchEscalationClient
    }
    if (searchClientType) {
      searchValue.clientType = searchClientType
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_manage_deliverable_followup_export_excel`, searchValue)
      .then((response) => {
        const exportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const eventName = data && data.events && !isEmpty(data.events) ?
              data.events.filter((m) => m.eventname !== null && m.eventname !== undefined)
                .map(m => m.eventname).join(",") : "--"

            const eventDate = data && data.eventsDates && !isEmpty(data.eventsDates) ?
              data.eventsDates.filter((date) => date !== null && date !== undefined)
                .map(m => moment(m).format(dateFormate)).join(",") : "--"

            const eventDateValue = !isEmpty(eventDate)
              ? JSON.stringify(eventDate).replace(/","/g, "\n")
              : "--"

            const eventNameValue = !isEmpty(eventName)
              ? JSON.stringify(eventName).replace(/","/g, "\n")
              : "--"
            const previousFollowupRemarks = data.previousFollowupRemarks ? data.previousFollowupRemarks : ""

            const previousFollowupRemarksValue = !isEmpty(previousFollowupRemarks)
              ? previousFollowupRemarks.replace(/[\r\n,.]/gm, "")
              : "--"

            const futureFollowupRemarks = data.futureFollowupRemarks ? data.futureFollowupRemarks : ""

            const futureFollowupRemarksValue = !isEmpty(futureFollowupRemarks)
              ? futureFollowupRemarks.replace(/[\r\n,.]/gm, "")
              : "--"
            const followupReason = !isEmpty(data.followupReason) ? data.followupReason.map((m) => m.reasonName).join(",") : ""
            const followupReasonValue = !isEmpty(followupReason) ? JSON.stringify(followupReason).replace(/","/g, "\n")
              : "--"
            return {
              _id: data._id,
              sNo: index + 1,
              clientCode: data.clientCode ? data.clientCode : "--",
              clientName: data.clientName ? data.clientName : "--",
              clientStatus: data.clientStatus ? data.clientStatus : "--",
              leadNo: data.leadNo ? data.leadNo : '--',
              eventName: eventNameValue,
              eventDate: eventDateValue,
              crmName: data.CRM_Name ? data.CRM_Name : "--",
              followupDate: data.futureFollowUpDate ? moment(data.futureFollowUpDate).format(dateFormate) : "--",
              modeOfFollowup: data.futureModeOfFollowup ? data.futureModeOfFollowup : "--",
              futureRemarks: futureFollowupRemarksValue,
              issuesCount: data.issuesCount ? data.issuesCount : "--",
              followupStatus: data.followupStatus ? data.followupStatus : "--",
              aging: data.ageing ? Math.abs(data.ageing) : "--",
              previousRemarks: previousFollowupRemarksValue,
              brideName: data.brideName ? data.brideName : "--",
              groomName: data.groomName ? data.groomName : "--",
              previousFollowupDate: data.followupDate ? moment(data.followupDate).format(dateFormate) : "--",
              createdByName: data.createdByName ? data.createdByName : "--",
              isEscalationCall: data.isEscalationCall == true ? "YES" : "No",
              followupReason: followupReasonValue,
              clientType: data.clientType,
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo, Lead No, Is Escalation Call,Is Escalation Client,Client Type, Followup Reason,Bride name, Groom Name, Events, Event Dates, CRM  Name,Previous Followup Date,Future Follow-up Date, Mode Of Follow-up,Followed By,  Future Remarks,  Issues Count,  Follow-up Status, Ageing, Previous Followup  Remarks",
          ]

          let usersCsv =
            !isEmpty(exportDataTable) &&
            exportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                isEscalationCall,
                isEscalationClient,
                clientType,
                followupReason,
                brideName,
                groomName,
                eventName,
                eventDate,
                crmName,
                followupDate,
                previousFollowupDate,
                modeOfFollowup,
                createdByName,
                futureRemarks,
                issuesCount,
                followupStatus,
                aging,
                previousRemarks
              } = user
              acc.push([
                sNo,
                leadNo,
                isEscalationCall,
                isEscalationClient,
                clientType,
                followupReason,
                brideName,
                groomName,
                eventName,
                eventDate,
                crmName,
                followupDate,
                previousFollowupDate,
                modeOfFollowup,
                createdByName,
                futureRemarks,
                issuesCount,
                followupStatus,
                aging,
                previousRemarks
              ])


              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "OperationsMyFollowup.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => {
        setDownloadLoading(false)
        Promise.reject(error)
      })
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          noDataIndication={"No Data Found..."}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: followup_details.length,
    data:
      !isEmpty(followup_details) && followup_details.length > 0
        ? followup_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(followup_details) && followup_details.length > 0
        ? followup_details
        : []
    if (

      !isEmpty(clientProfileStatus) ||
      !isEmpty(operationsFollowupData.eventFromDate) ||
      !isEmpty(operationsFollowupData.previousFollowupFromDate) ||
      !isEmpty(operationsFollowupData.previousFollowupToDate) ||
      !isEmpty(operationsFollowupData.eventToDate) ||
      !isEmpty(followupReason) ||
      !isEmpty(isEscalationCall)
    ) {

      var searchClientProfileStatus = !isEmpty(clientProfileStatus)
        ? clientProfileStatus.value
        : ""

      var searchEventFromDate =
        operationsFollowupData && operationsFollowupData.eventFromDate
          ? moment(operationsFollowupData.eventFromDate).format("YYYY-MM-DD")
          : ""
      var searchEventToDate =
        operationsFollowupData && operationsFollowupData.eventToDate
          ? moment(operationsFollowupData.eventToDate).format("YYYY-MM-DD")
          : ""
      var searchPreviousFromDate =
        operationsFollowupData && operationsFollowupData.previousFollowupFromDate
          ? moment(operationsFollowupData.previousFollowupFromDate).format("YYYY-MM-DD")
          : ""
      var searchPreviousToDate =
        operationsFollowupData && operationsFollowupData.previousFollowupToDate
          ? moment(operationsFollowupData.previousFollowupToDate).format("YYYY-MM-DD")
          : ""
      var searchEscalation = isEscalationCall
        ? isEscalationCall
        : ""
      var searchFollowupReason = !isEmpty(followupReason)
        ? followupReasons
        : ""
        var searchEscalationClient = isEscalationClient
        ? isEscalationClient
        : ""
      var searchClientType = !isEmpty(clientType)
        ? clientType.value
        : ""
      var searchValue = {}
      searchValue.page = page
      searchValue.limit = sizePerPage ? sizePerPage : 50
      searchValue.CRM_Id = empId

      if (searchClientProfileStatus) {
        searchValue.clientStatus = searchClientProfileStatus
      }

      if (searchEventFromDate) {
        searchValue.futureFollowupFromDate = searchEventFromDate
      }
      if (searchEventToDate) {
        searchValue.futureFollowupToDate = searchEventToDate
      }
      if (searchPreviousFromDate) {
        searchValue.previousFollowupFromDate = searchPreviousFromDate
      }
      if (searchPreviousToDate) {
        searchValue.previousFollowupToDate = searchPreviousToDate
      }
      if (searchFollowupReason) {
        searchValue.followupReasonId = searchFollowupReason
      }
      if (searchEscalation) {
        searchValue.isEscalationCall = searchEscalation
      }
      if (searchEscalationClient) {
        searchValue.isEscalationClient = searchEscalationClient
      }
      if (searchClientType) {
        searchValue.clientType = searchClientType
      }
      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(followupAction.loadFollowup(searchValue))
    } else {
      dispatch(
        followupAction.loadFollowup({
          page: page,
          limit: sizePerPage,
          CRM_Id: empId
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  const submitFollowup = () => {
    setFollowupStatusModal(false)
    const update_details = {
      "followupId": followupDetails._id,
      "followupStatus": "CLOSED"
    }

    dispatch(updateAction.updateFollowup(update_details))
    setTimeout(() => {
      dispatch(followupAction.loadFollowup(searchValue))
      toast.success("Followup Completed successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 500)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Operations"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Label"}>
                            {"Client Status"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="clientProfileStatus"
                          value={clientProfileStatus}
                          options={clientProfileStatusOptions}
                          onChange={(e) => {
                            setClientProfileStatus(e)
                          }}
                          placeholder="Select Client Status"
                        />
                      </Col>


                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Lead Date"}>
                            {"Future Followup From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventFromDate"
                          value={operationsFollowupData.eventFromDate}
                          max={operationsFollowupData.eventToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Lead Date"}>
                            {"Future Followup To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="eventToDate"
                          value={operationsFollowupData.eventToDate}
                          min={operationsFollowupData.eventFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Lead Date"}>
                            {"Previous Followup From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="previousFollowupFromDate"
                          value={operationsFollowupData.previousFollowupFromDate}
                          max={operationsFollowupData.previousFollowupToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Lead Date"}>
                            {"Previous Followup To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          name="previousFollowupToDate"
                          value={operationsFollowupData.previousFollowupToDate}
                          min={operationsFollowupData.previousFollowupFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Followup Reason"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          isMulti
                          name="followupReason"
                          value={followupReason}
                          onChange={(e) => setFollowupReason(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.followupReasonOptions
                              : []
                          }
                          placeholder="Select Followup Reason"
                          classNamePrefix="select2-selection"
                        />

                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                        <div className="d-flex flex-row">
                          {statusList.map((status, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isEscalationCall"
                                  value={status.value}
                                  checked={isEscalationCall === status.value}
                                  onChange={(e) =>
                                    handleStatusChange(e, status.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {status.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                        <div className="d-flex flex-row">
                          {statusClientList.map((status, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isEscalationClient"
                                  value={status.value}
                                  checked={isEscalationClient === status.value}
                                  onChange={(e) =>
                                    handleStatusClientChange(e, status.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {status.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"Label"}>
                            {"Client Type"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="clientType"
                          value={clientType}
                           options={
                            [{ label: "Green", value: "Green" },
                            { label: "Blue", value: "Blue" },
                            { label: "Orange", value: "Orange" },
                            ]
                          }
                          onChange={(e) => {
                            setClientType(e)
                          }}
                          placeholder="Select Client Type"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={clientDetailsReportTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      followup_details.totalDataCount
                        ? followup_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {columnModal && (
            <Modal size="xl" show={columnModal}>
              <Modal.Header
                style={{
                  backgroundColor: "white",
                  color: "black",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Edit Columns
                <span>
                  <i
                    className="fa fa-times quote-close"
                    aria-hidden="true"
                    onClick={() => setColumnModal(false)}
                  ></i>
                </span>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <div>
                    <Input
                      type="checkbox"
                      checked={selectedColumns.length === columns.length}
                      onChange={(e) => handleSelectAllChange(e)}
                      style={{ width: "15px", height: "15px" }}
                    />
                    <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                      Select All
                    </Label>
                  </div>
                </Row>
                <Row>
                  <Col sm="12" md="6" lg="6" className="ml-4">
                    {oddColumnData.map((column) => (
                      <div key={column.dataField} className="d-flex flex-row">
                        <div className="form-check form-check-inline">
                          <Input
                            type="checkbox"
                            value={column.dataField}
                            checked={selectedColumns.includes(column.dataField)}
                            onChange={(e) => handleCheckboxChange(e)}
                            style={{ width: "15px", height: "15px" }}
                          />
                          <Label
                            style={{
                              fontSize: "16px",
                              marginLeft: "10px",
                            }}
                          >
                            {column.text}
                          </Label>
                        </div>
                      </div>
                    ))}
                  </Col>
                  <Col sm="12" md="6" lg="6">
                    {evenColumnData.map((column) => (
                      <div key={column.dataField} className="d-flex flex-row">
                        <div className="form-check form-check-inline">
                          <Input
                            type="checkbox"
                            value={column.dataField}
                            checked={selectedColumns.includes(column.dataField)}
                            onChange={(e) => handleCheckboxChange(e)}
                            style={{ width: "15px", height: "15px" }}
                          />
                          <Label
                            style={{
                              fontSize: "16px",
                              marginLeft: "10px",
                            }}
                          >
                            {column.text}
                          </Label>
                        </div>
                      </div>
                    ))}
                  </Col>
                </Row>
              </Modal.Body>

              <Modal.Footer>
                <p
                  className="text-decoration-underline text-info"
                  style={{ cursor: "pointer", fontSize: "16px" }}
                  onClick={handleRestoreToDefault}
                >
                  Restore To Default
                </p>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setColumnModal(false)
                    setSelectedColumns(selectColumn)
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => handleSaveColumns()}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
          {followupStatusModal && (
            <Modal size="md" show={followupStatusModal}>
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Confirm
              </Modal.Header>
              <Modal.Body>
                Are You Sure Do You Want To Close Followup Status?
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => setFollowupStatusModal(false)}
                >
                  No
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={() => submitFollowup()}
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

OperationsMyFollowup.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})
//OperationsMyFollowup
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OperationsMyFollowup)
)
